import { io } from 'socket.io-client';

import { getBackendUrl } from './helpers/url';
import { getToken } from './helpers/auth';

const URL = getBackendUrl();
export const socket = io(URL, {
  transports: ['websocket', 'polling'],
  auth: (cb) => cb({ token: getToken() || '' }),
});
